@if (displayBanner) {
  <div class="alert-container">
    <nz-alert
      nzType="info"
      [nzMessage]="displayMsg">
    </nz-alert>
  </div>
}
